import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

const ArrowForwardXS = createSvgIcon(
  <path d="M2.04 11 1 9.952 4.92 6 1 2.048 2.04 1 7 6l-4.96 5Z" />,
  'ArrowForwardXS'
);

export { ArrowForwardXS };